export default {"src":"/_next/static/media/visa.36ad5477.svg","height":325,"width":1000,"blurWidth":0,"blurHeight":0};